export default "__VITE_ASSET__92ef85f1__"